//入力された文字数をチェックする
export default {
  validate(
    value: string | undefined | null,
    { min, max }: Record<string, string | number | undefined | null>
  ): boolean {
    if (value) {
      return value.length >= Number(min) && value.length <= Number(max);
    }
    return true;
  },
};
